import { Controller } from '@hotwired/stimulus';

export default class ValidateInputController extends Controller {
  static targets = ['commentTextValue', 'submitButton'];

  checkEmpty () {
    const disable = this.commentTextValueTarget.value.trim().length === 0;
    this.submitButtonTarget.disabled = disable;
  }
}
